import { Container as MuiContainer, type ContainerProps } from '@mui/material'
import { layout } from '@/theme'

/** Page-width container locked to the brand max width (1320px) with responsive gutters. */
export function Container({ sx, children, ...props }: ContainerProps) {
  return (
    <MuiContainer
      maxWidth={false}
      sx={{ maxWidth: layout.containerMaxWidth, mx: 'auto', px: { xs: 3, sm: 4, md: 5 }, ...sx }}
      {...props}
    >
      {children}
    </MuiContainer>
  )
}
